// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from 'vuestic-ui/src/services/ColorThemePlugin'
import store from '@/store/index'
import router from '@/router/index'
import VuesticPlugin from 'vuestic-ui/src/components/vuestic-plugin'
import '@/i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VeeValidate from 'vee-validate';
import Toasted from 'vue-toasted';
import '@/metrics'
import socket from './socket'
import VueChatScroll from 'vue-chat-scroll'

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(Toasted);
Vue.use(VueChatScroll)
Vue.use(ColorThemePlugin,
  {
    // Add or change theme colors here
    themes: {
      primary: '#bc5258 ',
      secondary: '#151c46',
      blurple: '#8d0c14',
      success: '#898BB5',
    },
  })

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  socket,
  store,
  render: h => h(App),
});
